import { useCallback } from 'react';

import { FabricChannel } from '@atlaskit/analytics-listeners';
import { type AnalyticsEventPayload, useAnalyticsEvents } from '@atlaskit/analytics-next';

const ANALYTICS_CHANNEL: FabricChannel.aiMate = FabricChannel.aiMate;
const ANALYTICS_SOURCE = 'rovoGrowthPulse';
const DEFAULT_TAGS: string[] = ['atlaskit'];

/**
 * Hook that returns a function to fire analytics events on the aiMate channel.
 * Automatically injects the package source into every event.
 */
export const useFireAnalyticsEvent = (): {
	fireAnalyticsEvent: (payload: AnalyticsEventPayload) => void;
} => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fireAnalyticsEvent = useCallback(
		(payload: AnalyticsEventPayload): void => {
			createAnalyticsEvent({
				...payload,
				source: ANALYTICS_SOURCE,
				tags: Array.from(new Set([...DEFAULT_TAGS, ...((payload.tags as string[]) ?? [])])),
				attributes: {
					...payload.attributes,
				},
			}).fire(ANALYTICS_CHANNEL);
		},
		[createAnalyticsEvent],
	);

	return { fireAnalyticsEvent };
};
